<template name = "dateTemplate" lang="html">
	<div class="row">
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
				</div>
				<div class="row row-xs">
					<div class="col-sm-6 col-lg-1 p-0">
						<div class="card card-body p-2">
							<b-menu :accordion="false">
								<b-menu-list label="">
									<b-menu-item :expanded="true" v-for="form in companyData" :key="form.id" :label="form[companyNameCode]" :id="form.id" @click="classifyDepartment(form.id)" icon="briefcase" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1"></b-menu-item>
								</b-menu-list>
							</b-menu>
						</div>
					</div>
					<div class="col-sm-6 col-lg-10">
						<div class="card card-body flex-column-inherit">
							<div class="col-sm-6 col-lg-3-5 d-inline-block">
								<h6>Department Depth 1</h6>
								<draggable class="list-group" :list="mainDept" group="dept0" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in mainDept" :key="form.id">
										<input type="email" class="form-control display-inline-block w-70" v-model="form.kor">
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptEdit(1, i)">
											<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptDelete(1, form)" v-if="form.id != (i+'_temp')">
											<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="nextDept(form.id, form.depth)" v-if="form.id != (i+'_temp')">
											<feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
									</div>
								</draggable>
								<div class='pt-2'>
									<input type="email" class="form-control display-inline-block w-65" v-model="mainTxt" @keyup.enter="deptAdd(1)">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptAdd(1, true)">
										<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
									</a>
								</div>
							</div><!-- col -->
							<div class="col-sm-6 col-lg-3-5" :class="{'d-none': secondDisplay}">
								<div class="dept-margin-bottom"><h6 class="display-inline-block">Department Depth 2</h6><feather type="x-square" @click="deptClosed('0100')" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather></div>
								<draggable class="list-group" :list="secondDept" group="dept0" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in secondDept" :key="form.id">
										<input type="email" class="form-control display-inline-block w-70" :value="form.kor">
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptEdit(2, i)">
											<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptDelete(2, form)" v-if="form.id != (i+'_temp')">
											<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="nextDept(form.id, form.depth)"  v-if="form.id != (i+'_temp')">
											<feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
									</div>
								</draggable>
								<div class='pt-2'>
									<input type="email" class="form-control display-inline-block w-65" v-model="secondTxt" @keyup.enter="deptAdd(2)">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptAdd(2, true)">
										<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
									</a>
								</div>
							</div><!-- col -->
							<div class="col-sm-6 col-lg-3-5" :class="{'d-none': thirdDisplay}">
								<div class="dept-margin-bottom"><h6 class="display-inline-block">Department Depth 3</h6><feather type="x-square" @click="deptClosed('1000')" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather></div>
								<draggable class="list-group" :list="secondDept" group="dept0" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in thirdDept" :key="form.id">
										<input type="email" class="form-control display-inline-block w-70" :value="form.kor">
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptEdit(3, i)">
											<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptDelete(3, form)" v-if="form.id != (i+'_temp')">
											<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
									</div>
								</draggable>
								<div class='pt-2'>
									<input type="email" class="form-control display-inline-block w-65" v-model="thirdTxt" @keyup.enter="deptAdd(3)">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="deptAdd(3, true)">
										<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
									</a>
								</div>
							</div><!-- col -->
						</div>
					</div>
				</div><!-- row row-xs -->
			</div><!-- container -->
		</div><!-- content -->
	</div>
</template>
<script>
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../../main";
	// vue draggable api import
	import draggable from "vuedraggable";

	export default {
		name: "Department",
		// order: 1,
		props: ['properties'],
		data() {
			return {
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
				companyData: [],
				companyNameCode: [],
				thisCompany:'',
				deptAll: [], // 부서정보
				setDept: [], // 초기 Depth Setting
				parentid: '',
				mainDept: [],
				mainTxt: '',
				secondDept: [],
				secondDisplay: true,
				secondTxt: '',
				thirdDept: [],
				thirdDisplay: true,
				thirdTxt: '',
			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyCompany();
			});
		},
		mounted() {
		},
		components: {
			draggable
		},
		methods: {
			/*
			* Load Data Company
			*/
			async classifyCompany(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];

				let menuid = common.menuidSearch(this.menuData, 'companies')
				let companyHeader = common.menuHeader(menuid, this.menuData)[3];
				this.companyNameCode = common.find_last_column(companyHeader, 'companyname');

				var params = { mid: menuid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/companies/search", request)
				.then(res => {
					this.companyData = res.data.list
				})
				.catch(error => {throw error;});
			},
			/*
			* Load Data Department Headers & depth type array setting
			*/
			async classifyDepartment(companyid){
				this.deptAll = [];
				this.mainDept = [];
				this.secondDept = [];
				this.thirdDept = [];
				this.thisCompany = companyid;
				var params = { companyId: companyid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/depts", request)
				.then(res => {
					this.deptAll = res.data;
				})
				let preDepth = '';
				this.deptAll.sort((a, b)=>{return a.depth - b.depth;}); // 정렬 이후 make data
				this.deptAll.forEach(a=>{
					if(Number(a.depth) > 0){
						if(preDepth != a.depth){
							this.setDept.push(a);
							preDepth = a.depth;
						}
					} 
				}); // dept Setting
				this.setDept.sort((a, b)=>{return a.sort - b.sort;}); // setDept sort
				this.deptAll.forEach(a=>{
					if(a.depth === '0010') this.mainDept.push(a)
				}); // 1 depth data setting
				this.mainDept.sort((a, b)=>{return a.sort - b.sort;}); // setDept sort
			},
			deptEdit: function(depth, sort) {
 				if(depth === 1){
					 let data = this.mainDept[sort]; 
					if(data.id.indexOf('temp') > 0) data.id = '';
					
					if(data.id.length > 0) this.deptUpdate(1, data);
					else this.deptCreate(1, data);
					
				}else if (depth === 2){
					 let data = this.secondDept[sort];
					if(data.id.indexOf('temp') > 0) data.id = '';
					
					if(data.id.length > 0) this.deptUpdate(2, data);
					else this.deptCreate(2, data);
				}else{
					 let data = this.thirdDept[sort]; 
					if(data.id.indexOf('temp') > 0) data.id = '';
					
					if(data.id.length > 0) this.deptUpdate(3, data);
					else this.deptCreate(3, data);
				}
			},
			/*
			* data insert
			*/
			async deptCreate(depth, data) {
				data.companyId = this.thisCompany;
				console.log(data)
				 await this.$axios.post(this.$apiHost+'/depts', data)
				.then(res=>{
					if(depth == 1) {
						this.mainDept.splice(data.sort, 1, res.data);
					}else if(depth == 2) {
						this.secondDept.splice(data.sort, 1, res.data);
					}else {
						this.thirdDept.splice(data.sort, 1, res.data);
					}
					this.deptAll.push(res.data);
				}).catch(err=>{console.log(err)});
			},
			/*
			* data update
			*/
			async deptUpdate(depth, data) {
				await this.$axios.patch(this.$apiHost+'/depts/update', data)
				.then(res=>{
					if(depth == 1) {
						this.mainDept.splice(data.sort, 1, res.data);
					}else if(depth == 2) {
						this.secondDept.splice(data.sort, 1, res.data);
					}else {
						this.thirdDept.splice(data.sort, 1, res.data);
					}
					this.deptAll.push(res.data);
				}).catch(err=>{console.log(err)});
			},
			/*
			* delete data
			*/
			async deptDelete(depth, data) {
				console.log('delete')
				console.log(data)
				await this.$axios.patch(this.$apiHost+'/depts/delete', data)
				.then(res=>{
					if(depth == 1) {
						this.mainDept.splice(data.sort, 1);
					}else if(depth == 2) {
						this.secondDept.splice(data.sort, 1);
					}else {
						this.thirdDept.splice(data.sort, 1);
					}
					this.deptAll.some((a, b)=>{
						if(a.id === data.id){
							this.deptAll.splice(b, 1);
							return true;
						}
					});
				}).catch(err=>{console.log(err)}); 
			},
			/*
			* department add button
			*/
			deptAdd: function(depth, click) {
 				if(depth === 1){
					if(click){
						this.mainDept.push({id:this.mainDept.length+'_temp',eng:'',kor:this.mainTxt,depth:'0010',sort:this.mainDept.length,parent:''},);
						this.mainTxt = '';
					}else{
						if(this.mainTxt.length > 0){
							this.mainDept.push({id:this.mainDept.length+'_temp',eng:'',kor:this.mainTxt,depth:'0010',sort:this.mainDept.length,parent:''},);
							this.mainTxt = '';
						}
					}
				}else if (depth === 2){
					if(click){
						this.secondDept.push({id:this.secondDept.length+'_temp',eng:'',kor:this.secondTxt,depth:'0100',sort:this.secondDept.length,parent:this.parentid},);
						this.secondTxt = '';
					}else{
						if(this.secondTxt.length > 0){
							this.secondDept.push({id:this.secondDept.length+'_temp',eng:'',kor:this.secondTxt,depth:'0100',sort:this.secondDept.length,parent:this.parentid},);
							this.secondTxt = '';
						}
					}
				}else{
					if(click){
						this.thirdDept.push({id:this.thirdDept.length+'_temp',eng:'',kor:this.thirdTxt,depth:'1000',sort:this.thirdDept.length,parent:this.parentid},);
						this.thirdTxt = '';
					}else{
						if(this.thirdTxt.length > 0){
							this.thirdDept.push({id:this.thirdDept.length+'_temp',eng:'',kor:this.thirdTxt,depth:'1000',sort:this.thirdDept.length,parent:this.parentid},);
							this.thirdTxt = '';
						}
					}
				}
			},
			/*
			* department depth close
			*/
			deptClosed: function(depth) {
				if(depth === '0100')this.secondDisplay = true;
				else if(depth === '1000')this.thirdDisplay = false;
			},
			/*
			* department next depth open
			*/
			nextDept: function(parent, depth) {
				if(depth === '0010'){
					this.parentid = parent;
					this.secondDisplay = false;
					this.thirdDisplay = true;
					this.secondDept = [];
					this.thirdDept = [];
					this.deptAll.forEach(a=>{
						if(a.parentId === parent) this.secondDept.push(a);
					});
				}else if(depth === '0100'){
					this.parentid = parent;
					this.thirdDisplay = false;
					this.thirdDept = [];
					this.deptAll.forEach(a=>{
						if(a.parentId === parent) this.thirdDept.push(a);
					});
				// }else if(depth === '1000'){
				}
			},
			/*
			* drable log
			*/
			log: function(evt) {
				window.console.log(evt);
			},
		},
		computed: {
			draggingInfo() {
				return this.dragging ? "under drag" : "";
			}
		},
		watch: {
		},
	}
</script>
<style scoped>
	@import "../../../assets/css/buefy.css";
</style>


// WEBPACK FOOTER //
// src/views/Management/Department/List.vue